import React from 'react';

import pluralize from 'pluralize';

import { useSelector } from 'bundles/research/index/store/hooks';

import NewPropertyButton from 'bundles/research/index/properties/new/button';
import PropertiesActionDropdown from 'bundles/research/index/properties/properties_action_dropdown';

export default function PropertiesIndexHeaderEdgeCrm() {
  const currentTab = useSelector(state => state.ui.currentTab);
  const importerProps = useSelector(state => state.importerProps);
  const insights = useSelector(state => state.features.insights);
  const newPropertyPath = useSelector(state => state.paths.newProperty);
  const totalCount = useSelector(state => state.search.meta.totalCount);

  return (
    <div className="index-page-header d-flex align-items-center p-4 border-bottom">
      <h1 className="flex-1 m-0">Properties</h1>

      {currentTab !== 'maps' &&
        <span className="text-muted">{pluralize('Property', totalCount, true)}</span>
      }

      <PropertiesActionDropdown/>
      <NewPropertyButton
        edgeCrm
        importerProps={importerProps}
        insights={insights}
        newPropertyPath={newPropertyPath}
      />
    </div>
  );
}
